import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import {
  ConnectionsSelectors,
  CreateBotConnection,
  RemoveBotConnection,
  UpdateBotConnection,
} from 'projects/brn-frontend/src/app/core/store/bot-connections';

@Component({
  selector: 'brn-telegram-connection-modal',
  templateUrl: './telegram-connection-modal.component.html',
  styleUrls: ['./telegram-connection-modal.component.scss'],
})
export class TelegramConnectionModalComponent implements OnInit {
  @ViewSelectSnapshot(ConnectionsSelectors.pendingStatus)
  pendingStatus!: boolean;

  newConnection = true;

  telegramForm = this.formBuilder.group({
    token: ['', Validators.required],
    username: ['', Validators.required],
  });

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<TelegramConnectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.providerData) {
      const providerData = data.providerData;
      this.newConnection = false;
      this.telegramForm.patchValue(providerData);
    }
  }

  ngOnInit(): void {}

  get validForm(): boolean {
    return this.telegramForm.valid;
  }

  createConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.telegramForm.value;
    this.store.dispatch(new CreateBotConnection('telegram', providerData));
  }

  updateConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.telegramForm.value;
    this.store.dispatch(new UpdateBotConnection('telegram', providerData));
  }

  removeConnection(): void {
    if (this.pendingStatus) {
      return;
    }
    this.store.dispatch(new RemoveBotConnection('telegram'));
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
